<template>
  <div class="in-modal">
    <modal name="pdf-export"
        transition="nice-modal-fade"
        :min-width="200"
        :min-height="200"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="80%"
        height="auto"
    >
      <div class="header">
        <h1>{{ $t("message.pdf_file_generate") }}</h1>
      </div>
      <div class="content row">
        <div class="col-lg-12 info">
          {{ $t("message.pdf_file_generate_text") }}.
          <Loader/>
        </div>
        <div class="col-lg-12 buttons">
          <button class="btn btn-default" @click="hide('pdf-export')">{{ $t("message.cancel") }}</button>
        </div>
      </div>
    </modal>
    <button class="btn btn-primary btn-block" @click="download()"><i class="fa fa-file-pdf-o"></i>&nbsp;&nbsp;pdf</button>
  </div>
</template>

<script>
import Loader from '../Loader'
export default {
  name: 'PdfExport',
  components: {
    Loader,
  },
  data () {
    return {
      format: 'pdf',
      disabled: false,
    }
  },
  methods: {
    show(name) {
      this.$modal.show(name);
    },
    hide(name) {
      this.$modal.hide(name);
    },
    download() {
      window.open(this.url);
    },
  },
  computed: {
    url() {
      return this.axios.defaults.baseURL+'pricelist'+this.storage_url_ids+'?format='+this.format+'&discount='+this.discount+'&lang='+this.locale;
    },
    storage_url_ids() {
      const storage = this.$store.getters['pricelist/storage'];
      const is_storage = this.$store.getters['pricelist/is_storage'];
      const ids = storage.map(item => item.id);
      if(is_storage && storage.length) {
        return '/'+ids+'/';
      }
      return '';
    },
    discount() {
      return this.$store.getters['pricelist/discount'];
    },
    locale() {
      return this.$store.getters['pricelist/locale'];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

@color: #f15642;

.in-modal {
  h1 {
    margin-bottom: 0;
    font-size: 1.4em;
  }
  .content {
    padding: 15px 30px;
    .separator {
      select {
        font-size: .8em;
        option {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          padding: 15px 0;
        }
      }
    }
  }
  .header {
    background: @color;
    padding: 15px 30px;
    color: #fff;
  }
  .form-check-label {
    font-size: .8em;
  }
  .buttons {
    margin-top: 30px;
    text-align: right;
  }
}
.btn-primary,
.btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle {
  background: @color;
  color: #fff;
  border-color: @color;
}
.animation {
  margin: 15px auto;
}
</style>




// WEBPACK FOOTER //
// src/components/Export/PdfExport.vue